exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-circle[data-v-6cee0efc] {\n  border: 1px solid var(--color-primary);\n  border-radius: 50%;\n  padding: 7px;\n}", ""]);

// exports
